import { GetInputPropsReturnType } from "@mantine/form";
import { DateToTimestamp, TimestampToDate } from "./DateHelper";

export function ConvertToTimestampInputProps(
    inputProps: GetInputPropsReturnType
): GetInputPropsReturnType {
    const { value, onChange, ...rest } = inputProps;

    return {
        ...rest,
        value: TimestampToDate(value ?? 0),
        onChange: (val: string) => onChange(DateToTimestamp(new Date(val))),
    };
}